import { useState } from "react";
import { Routes, Route } from "react-router-dom";
import Statuses from "./Statuses";
import StatusCreateEdit from "./StatusCreateEdit";
import { CallType, StatusType } from "__generated__/enums";

const index = () => {

	const [ statusType, setStatusType ] = useState(StatusType.Cargo);
	const [ cargoActionType, setCargoActionType ] = useState<CallType | null>(null);

	return (
		<Routes>
			<Route
				index
				element={(
					<Statuses
						statusType={statusType}
						cargoActionType={cargoActionType}
						setStatusType={setStatusType}
						setCargoActionType={setCargoActionType}
					/>
				)} />

			<Route
				path='/create'
				element={(
					<StatusCreateEdit
						statusType={statusType}
						setStatusType={setStatusType} />
				)} />

			<Route
				path='/:id/edit'
				element={(
					<StatusCreateEdit
						statusType={statusType}
						setStatusType={setStatusType} />
				)} />
		</Routes>
	);
};

export default index;
